import React from 'react';
import { Link } from 'react-router';

class LostKeyComboCallouts extends React.Component {
	constructor(props) {
		super(props);
		this.handleClick= this.handleClick.bind(this);
	}
	
	handleClick(e) {
		global.dataLayer.push({
			event: 'Lost Key Combo',
			eventCategory: 'Support',
			eventAction: e.currentTarget.textContent,
			eventLabel: global.location.pathname
		});
	}

	render() {
		const currentUrl= "/support/lost-key-combo";
		return (
			<div className="lost-key-combo">
				<div className="replacement-process-callouts">
					<div className="row">
						<div className="col sm-6">
							<Link
								className="replacement-process-callout"
								to={currentUrl+"/US"}
								onClick={ e => this.handleClick(e) }
							>
								<div>
									<img
										src={ require('../../../resources/img/icons/key-icon.png') }
										srcSet={ `${require('../../../resources/img/icons/key-icon@2x.png')} 2x` }
										alt="Key"
									/>
									<img
										src={ require('../../../resources/img/icons/combo-icon.png') }
										srcSet={ `${require('../../../resources/img/icons/combo-icon@2x.png')} 2x` }
										alt="Combo"
									/>
								</div>
								<p className="arrow-link">
									Key &amp; Combo Replacement Process <br/> US
								</p>
							</Link>
						</div>
						<div className="col sm-6">
							<Link
								className="replacement-process-callout"
								to={currentUrl+"/UK"}
								onClick={ e => this.handleClick(e) }
							>
								<div>
									<img
										src={ require('../../../resources/img/icons/key-icon.png') }
										srcSet={ `${require('../../../resources/img/icons/key-icon@2x.png')} 2x` }
										alt="Key"
									/>
									<img
										src={ require('../../../resources/img/icons/combo-icon.png') }
										srcSet={ `${require('../../../resources/img/icons/combo-icon@2x.png')} 2x` }
										alt="Combo"
									/>
								</div>
								<p className="arrow-link">
									Key &amp; Combo Replacement Process <br/> UK
								</p>
							</Link>
						</div>
						
					</div>
				</div>
			</div>
		);
	}
};

export default LostKeyComboCallouts;


// WEBPACK FOOTER //
// ./src/pages/support/lostKeyCombo/LostKeyComboCallouts.js